import { createStyles, makeStyles } from '@material-ui/styles';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      gap: '20px',
      width: 'available',
      '@media (max-width: 1279px)': {
        flexDirection: 'column'
      }
    },
    dashboard: {
      '@media (max-width: 1279px)': {
        flexDirection: 'column-reverse'
      }
    },
    col1dashboard: {
      width: '65%',
      '@media (max-width: 1279px)': {
        width: 'auto'
      }
    },
    col2dashboard: {
      width: '35%',
      '@media (max-width: 1279px)': {
        width: 'auto'
      }
    },
    col1reverse: {
      width: '35%',
      '@media (max-width: 1279px)': {
        width: 'auto'
      }
    },
    col2reverse: {
      width: '65%',
      '@media (max-width: 1279px)': {
        width: 'auto'
      }
    },
    col1: {
      width: '65%',
      '@media (max-width: 1279px)': {
        width: 'auto'
      }
    },
    col2: {
      width: '35%',
      '@media (max-width: 1279px)': {
        width: 'auto'
      }
    },
    col1productSingle: {
      width: '75%',
      '@media (max-width: 1279px)': {
        width: 'auto'
      }
    },
    col2productSingle: {
      width: '25%',
      '@media (max-width: 1279px)': {
        width: 'auto'
      }
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
